import React from 'react'
import ChiefComplaint from './itemsPreview/ChiefComplaint';
import Problems from './itemsPreview/Problems';
import Vitals from './itemsPreview/Vitals';
import HPI from './itemsPreview/HPI';
import ROS from './itemsPreview/ROS';
import FollowUp from './itemsPreview/FollowUp';
import AdditionalInfo from './itemsPreview/AdditionalInfo';
import QualityOfCare from './itemsPreview/QualityOfCare';
import ProcedureCodes from './itemsPreview/ProcedureCodes';
import isNull from '../../../../../../../../../../utils/NullChecking';
// import Heading from './itemsPreview/Heading'
// import ChiefComplaint from './items/ChiefComplaint';
// import CheckList from './itemsPreview/CheckList'
// import Divider from './itemsPreview/Divider'
// import Dropdown from './itemsPreview/Dropdown'
// import SimpleQuestion from './itemsPreview/SimpleQuestion'
// import SingleChoice from './itemsPreview/SingleChoice'
// import MultiChoice from './itemsPreview/MultiChoice'
// import RatingScale from './itemsPreview/RatingScale'
// import YesNoQuestion from './itemsPreview/YesNoQuestion'
// import Notes from './itemsPreview/Notes'
// import Table from './itemsPreview/Table'
// import File from './itemsPreview/File'
// import Date from './itemsPreview/Date'
// import TextField from './itemsPreview/TextField'

const RenderFieldPreview = ({ item, setItem, ...props}) => {
  switch (!isNull(item.ItemID) && item.ItemID.split('-')[0]) {
    // Use the base ID to determine the type
    case 'ChiefComplaint':
      return <ChiefComplaint item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount}/>;

    case 'Problems':
      return <Problems item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount} />;
      
    case 'Vitals':
      return <Vitals item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount} />;
      
    case 'HPI':
      return <HPI item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount} />;
      
    case 'ROS':
      return <ROS item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount} />;
      
    case 'FollowUp':
      return <FollowUp item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount} />;
      
    case 'AdditionalInfo':
      return <AdditionalInfo> 
                {props?.widgetsPreviewData?.isOpenedFromSelectedModal === "true" ?
                <AdditionalInfo.SelectModalView  item={item} additionalInfoWidgetPreviewProps={props?.additionalInfoWidgetPreviewProps}  widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount}/> :
                <AdditionalInfo.Preview  item={item} additionalInfoWidgetPreviewProps={props?.additionalInfoWidgetPreviewProps}  widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount}/>}
            </AdditionalInfo>;
      
    case 'QualityOfCare':
      return <QualityOfCare item={item} widgetsPreviewData={props?.widgetsPreviewData} itemCount={props?.itemCount} />;
      
    case 'ProcedureCodes':
      return <ProcedureCodes> 
                {props?.widgetsPreviewData?.isOpenedFromSelectedModal === "true" ?
                <ProcedureCodes.SelectModalView  item={item} procedureCodesWidgetPreviewProps={props?.procedureCodesWidgetPreviewProps}  itemCount={props?.itemCount}/> :
                <ProcedureCodes.Preview  item={item} procedureCodesWidgetPreviewProps={props?.procedureCodesWidgetPreviewProps}  itemCount={props?.itemCount}/>}
            </ProcedureCodes>;
                  
    //   case 'TextField':
    //   return <TextField  item={item} />;

    //   // case 'Checklist':
    //   case 'CheckList':
    //   return <CheckList item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'Divider':
    //   return <Divider item={item} setItem={setItem} activeAccordion={activeAccordion}/>;

    //   case 'Dropdown':
    //   return <Dropdown item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'SimpleQuestion':
    //   return <SimpleQuestion item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;
        
    //   case 'SingleChoice':
    //   return <SingleChoice item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'MultiChoice': 
    //   return <MultiChoice item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'RatingScale':
    //   return <RatingScale item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;
      
    //   case 'YesNoQuestion':
    //   return <YesNoQuestion item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;
      
    //   case 'Notes': 
    //   return <Notes item={item} setItem={setItem} activeAccordion={activeAccordion}/>;
      
    //   case 'Table':
    //   return <Table item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'File':
    //   return <File item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;
      
    //   case 'Image':
    //   return <File item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'Signature':
    //   return <File item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;

    //   case 'Date':
    //   return <Date item={item} setItem={setItem} activeAccordion={activeAccordion}  itemCount={props?.itemCount}/>;
  
      default:
        return null;
    }
}

export default RenderFieldPreview